/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {inviteContacts} from '../api'

export const useMutationInviteContacts = createReactQueryMutationHook('inviteContacts', inviteContacts)
